const getRequest = (url) => {

    return handleResponse(
        fetch(url,
            {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window["dynamicTableApiToken"]),
                },
            }));
}

const postRequest = (url, data) => {

    return handleResponse(
        fetch(url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window["dynamicTableApiToken"])
                },
                body: JSON.stringify(data)
            }));
}
const PostRequestByFormData = (_url, _data) => {
    return handleResponse(fetch(
        _url,
        {

            method: 'POST',
            headers: {
                'ozt': localStorage.getItem(window["dynamicTableApiToken"])
            },
            'Content-Type': 'multipart/form-data',
            body: _data
        }
    ));
}

const putRequest = (url, data) => {

    return handleResponse(
        fetch(url,
            {
                method: 'put',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window["dynamicTableApiToken"])
                },
                body: JSON.stringify(data)
            }));
}

const deleteRequest = (url, data) => {

    return handleResponse(
        fetch(url,
            {
                method: 'delete',
                headers: {
                    'Content-Type': 'application/json',
                    'ozt': localStorage.getItem(window["dynamicTableApiToken"])
                },
                body: JSON.stringify(data)
            }));
}

const getFileRequest = (url, data) => {

    return fetch(url,
        {
            method: 'get',
            headers: {
                'Content-Type': 'application/octet-stream',
                'ozt': localStorage.getItem(window["dynamicTableApiToken"])
            },

        });
}
const handleResponse = (promise) => {

    return promise.then(response => {

        if (!response.ok) {

            if (response.status === 401) {

                return { success: false };
            }

            return Promise.reject(response.statusText);
        }

        return response.json();
    });
}

export const requestTool = {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    PostRequestByFormData,
    getFileRequest
}

export default requestTool;